import AzureDocumentServiceV1 from './v1';
import AzureDocumentServiceV2 from './v2';

export { AzureDocumentServiceV1, AzureDocumentServiceV2 };
export default AzureDocumentServiceV1;